// extracted by mini-css-extract-plugin
export default {"ratingLabel":"ProductDetailRating_ratingLabel__h5UyV","ratingIcon":"ProductDetailRating_ratingIcon__IFvVC"};